<template>
  <CBox width="100%">
    <!-- Resumo -->
    <CBox
      bg="#EAF8F3"
      border="1px solid #00A979"
      borderRadius="8px"
      py="16px"
      px="20px"
      mb="16px"
    >
      <OmtTypography
        as="h2-bold"
        color="var(--colors-light-primary-dark-blue)"
        mb="14px"
      >
        Resumo
      </OmtTypography>
      <OmtTypography
        as="p1"
        color="var(--colors-light-primary-gray1)"
        class="texto-relatorio"
      >
        {{ relatorio.summary }}
      </OmtTypography>
    </CBox>

    <!-- Avaliação -->
    <CBox
      v-if="relatorio.assessment"
      bg="#FFFFFF"
      border="1px solid #DADADA"
      borderRadius="8px"
      p="20px"
      mb="16px"
    >
      <OmtTypography
        as="h2-bold"
        color="var(--colors-light-primary-navy-blue)"
        mb="14px"
      >
        Avaliação
      </OmtTypography>
      <OmtTypography
        as="p1"
        color="#4E4E4E"
        fontSize="14px"
        lineHeight="20px"
        class="texto-relatorio"
      >
        {{ relatorio.assessment }}
      </OmtTypography>
    </CBox>

    <!-- Recomendações -->
    <CBox
      v-if="recomendacoes.length"
      bg="#FFFFFF"
      border="1px solid #DADADA"
      borderRadius="8px"
      p="20px"
      mb="16px"
    >
      <OmtTypography
        as="h2-bold"
        color="var(--colors-light-primary-navy-blue)"
        mb="14px"
      >
        Recomendações
      </OmtTypography>
      <CBox
        v-for="(recomendacao, idx) in recomendacoes"
        :key="'rec' + idx"
        :mt="idx > 0 ? '16px' : '0'"
      >
        <StatusTile
          v-chakra
          mb="8px"
          :label="recomendacao.rotulo"
          :color="recomendacao.cor"
        />
        <OmtTypography
          as="p1"
          color="#4E4E4E"
          fontSize="14px"
          lineHeight="20px"
          class="texto-relatorio"
        >
          {{ recomendacao.text }}
        </OmtTypography>
      </CBox>
    </CBox>

    <!-- Recados da equipe de saúde -->
    <CBox
      v-if="recados.length"
      bg="#FFFFFF"
      border="1px solid #DADADA"
      borderRadius="8px"
      p="20px"
      mb="16px"
    >
      <OmtTypography
        as="h2-bold"
        color="var(--colors-light-primary-navy-blue)"
        mb="14px"
      >
        Recados da equipe
      </OmtTypography>
      <OmtTypography
        v-for="(recado, idx) in recados"
        :key="'recado' + idx"
        as="p1"
        color="#4E4E4E"
        fontSize="14px"
        lineHeight="20px"
        :mt="idx > 0 ? '12px' : '0'"
        class="texto-relatorio"
      >
        {{ recado }}
      </OmtTypography>
    </CBox>

    <!-- Aviso / Disclaimer -->
    <OmtTypography
      v-if="relatorio.disclaimer"
      as="p2"
      color="var(--colors-light-primary-gray2)"
      mt="8px"
      mb="24px"
    >
      {{ relatorio.disclaimer }}
    </OmtTypography>
  </CBox>
</template>

<script>
import { CBox } from "@chakra-ui/vue";
import StatusTile from "@/components/Organisms/Requests/StatusTile";

// Tipo de recomendacao do relatorio da Plataforma Wellness.
const TIPOS_RECOMENDACAO = {
  clinica: { rotulo: "Procure um profissional", cor: "var(--colors-light-support-warning)" },
  wellness: { rotulo: "Hábitos", cor: "var(--colors-light-support-success)" }
};

/**
 * Relatorio da Plataforma Wellness (pele ou dados de saude): resumo, avaliacao, recomendacoes,
 * recados da equipe e aviso.
 * @prop { Object } relatorio summary, assessment, recommendations, reviewerNotes e disclaimer
 */
export default {
  name: "WellnessReport",
  components: { CBox, StatusTile },
  props: {
    relatorio: {
      type: Object,
      required: true
    }
  },
  computed: {
    recomendacoes() {
      return (this.relatorio?.recommendations || [])
        .filter(r => r?.text)
        .map(r => ({ ...r, ...(TIPOS_RECOMENDACAO[r.type] || TIPOS_RECOMENDACAO.wellness) }));
    },
    recados() {
      return (this.relatorio?.reviewerNotes || []).filter(Boolean);
    }
  }
};
</script>

<style scoped>
/* O relatorio pode vir com quebras de linha (ex.: texto editado pela equipe). */
.texto-relatorio {
  white-space: pre-line;
}
</style>
